import { AxiosInstance } from 'axios';
import { mapQueueDtoToModel, QueueDto, QueueModel } from 'api/dto/Queue.dto';

export class QueueApi {
  constructor(private api: AxiosInstance) {}

  list(id: number): Promise<QueueModel[]> {
    return this.api
      .get(`/api/v1/project/${id}/queue`)
      .then((response) => response.data.data)
      .then((entries: QueueDto[]) => entries.map(mapQueueDtoToModel));
  }

  get(id: number): Promise<QueueDto> {
    return this.api.get(`/api/v1/queue/${id}`).then((response) => response.data);
  }
}
